// src/services/ai/providers/CloudFunctionProvider.js
import AIProvider from './AIProvider';
import { functions } from '../../../firebase/config';
import { httpsCallable } from 'firebase/functions';

export default class CloudFunctionProvider extends AIProvider {
  getName() {
    return 'cloud-function';
  }

  async chat(messages, tools = []) {
    const cofounderChat = httpsCallable(functions, 'cofounderChat');

    const toolDefinitions = tools.map(tool => ({
      name: tool.name,
      description: tool.description,
      parameters: tool.parameters
    }));

    const result = await cofounderChat({
      messages,
      tools: toolDefinitions,
      provider: this.config.provider || 'gemini'
    });

    return {
      content: result.data.content || '',
      toolCalls: result.data.toolCalls || null
    };
  }
}
